// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Assets/img/icons/loop.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

body.no-scroll {
    overflow: hidden;
}

.no-cursor {
    cursor: none;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html {
    scroll-behavior: smooth;
}

body {
    overflow: hidden;
}

.ReactModal__Overlay {
    background: #00000040 !important;
    z-index: 11 !important;
}

.card__product__stake_active {
    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;
}


/*range */

.rangeslider-vertical {
    width: 8px !important;
    height: 176px !important;
    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;
    border-radius: 88px !important;
    background: #F0F0F3 !important;
    left: 5px !important;
    top: 0 !important;
    margin: 0 !important;
}

.rangeslider {
    margin: 2px 0 !important;
}

.rangeslider-vertical .rangeslider__handle-label {

    width: 16px !important;
    display: flex !important;
    height: 16px !important;
    border-radius: 50% !important;
    box-shadow: inset 2px 2px 2px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%) !important;
}

.card__slider .rangeslider-vertical .rangeslider__handle-label {
    background: #F27281 !important;
}

.rangeslider-vertical .rangeslider__handle {
    width: 27px !important;
    height: 27px !important;
    background: #F0F0F3;
    box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px rgb(54 54 77 / 40%) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50% !important;
    position: absolute !important;
    left: -9px !important;
    cursor: pointer !important;
}

.rangeslider-vertical .rangeslider__fill {

    box-shadow: inset 3px 3px 3px rgb(64 64 80 / 33%) !important;
    border-radius: 0px 0px 20px 20px !important;
}

.card__slider .rangeslider-vertical .rangeslider__fill {
    background: #F27281 !important;
}

.rangeslider__labels {
    display: none;
}

.rangeslider-horizontal {
    width: 105px !important;
    height: 8px !important;
    box-shadow: inset 3px 3px 3px #aeaec033, inset -3px -3px 3px #ffffffb2 !important;
    border-radius: 88px !important;
    background: #F0F0F3 !important;
}

.rangeslider-horizontal .rangeslider__fill {
    height: 100% !important;
    background: #F27281 !important;
    box-shadow: inset 3px 3px 3px #40405053 !important;
    border-radius: 20px 0 0 20px !important;
    position: absolute !important;
    left: 0 !important;
}

.rangeslider-horizontal .rangeslider__handle {
    width: 24px !important;
    height: 24px !important;
    background: #F0F0F3 !important;
    box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px #36364d67 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 50% !important;
    cursor: pointer !important;
}

.rangeslider-horizontal .rangeslider__handle-label {
    background: #F27281;
    width: 16px;
    display: flex;
    height: 16px;
    border-radius: 50%;
    box-shadow: inset 2px 2px 2px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%);
}

.rangeslider__handle::after {
    display: none !important;
}

.current__card .rangeslider-horizontal {
    width: 105px;
}


/* CUSTOM CSS TO CENTER PERCENTAGE IN PROGRESSBAR */
.card__risk__chart__min__wrapper,
.card__risk__chart__min__wrapper_aside {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.card__risk__chart__min__wrapper__defi__list {
    top: 50% !important;
}

.card__risk__chart__min__wrapper_aside {
    top: 35% !important;
}

.qr__logo {
    width: 100px;
    height: 100px;
    opacity: 1;
    display: flex;
    margin: 0 auto 20px;
}

.selected__type {
    border: 1px solid red;
}


input[type="file"] {
    display: none;
    cursor: pointer;
}

.avatarActions {
    display: none;
}

.user__info__avatar__wrapper:hover .avatarActions {
    display: block;
}

.upload__content {
    display: flex;
    flex-direction: row;
}

.upload__content {
    /* width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    box-shadow: -8px -8px 15px #ffffff, 8px 8px 15px #aeaec067;
    z-index: 2;
    background: transparent radial-gradient(closest-side at 50% 50%, #69686F00 0%, #6A697180 94%, #727179 100%) 0 0 no-repeat padding-box;
    opacity: 0;
    align-items: center;
    color: white;
    justify-content: center;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer; */

    padding: 2px 24px 2px 21px;
    position: absolute;
    top: 37%;
    left: 25%;
    border-radius: 24px;
    z-index: 2;
    background: rgba(54, 64, 72, 0.5);
    opacity: 1;
    align-items: center;
    color: white;
    justify-content: center;
    /* font-size: 18px; */
    font-weight: 600;
    cursor: pointer;
}

.upload__content:hover {

    background: #364048;
}

.deleteArea:hover {
    background: #364048;
}

.deleteArea {
    padding: 3px 19px 2px 22px;
    position: absolute;
    top: 50%;
    left: 25%;
    border-radius: 24px;
    z-index: 2;
    background: rgba(54, 64, 72, 0.5);
    opacity: 1;
    align-items: center;
    color: white;
    justify-content: center;
    /* font-size: 18px; */
    font-weight: 600;
    cursor: pointer;

}

.user__info__avatar__block:hover {
    background-color: rgba(105, 104, 111, 0.82);
    /* position: absolute;
    z-index: 10; */
}

.upload_title {
    cursor: pointer;
    /* margin-left:4px; */
}

.round__shdow {
    width: 168px;
    height: 168px;
    position: absolute;
    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;
    border-radius: 50%;
}

.card__round__shadow {
    width: 100px;
    height: 100px;
    position: absolute;
    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;
    border-radius: 50%;
}


.main.main_setting::after {
    display: none;
}

.main.empty__trash::after {
    display: none;
}


.card__slider_not_value .rangeslider-vertical .rangeslider__handle-label {
    background: #E3E2E2 !important;
}

.card__slider_not_value .rangeslider-vertical .rangeslider__fill {
    background: #E3E2E2 !important;
}


input:-webkit-autofill,
input:-webkit-autofill:focus {
    -webkit-transition: background-color 600000s 0s, color 600000s 0s !important;
    transition: background-color 600000s 0s, color 600000s 0s !important;
}

/* open */


.nav.open {
    width: 272px;
}

.nav.open .logo {
    width: 200px;
}

.nav.open .logo__img {
    display: none;
}

.nav.open .logo__img__big {
    display: inline-block;
    width: 100%;
    height: 100%;
}

.nav.open .nav__link {
    width: 208px;
}

.nav.open .nav__link .nav__text {
    font-size: 20px;
    position: relative;
    opacity: 1;
    visibility: visible;
    color: #364048;
}

.main.open {
    padding-left: 325px;
}

.header.open {
    padding-left: 296px;
}


.horizontal_slid_nit_value .rangeslider-horizontal .rangeslider__handle-label {
    background: #E3E2E2 !important;
}

.card__risk__alert__not_number {
    color: #889096 !important;
}

.css-1s2u09g-control {
    border: none !important;
    background: none !important;
    cursor: pointer !important;
}

.css-1okebmr-indicatorSeparator {
    background: none !important;
}

.css-2613qy-menu {
    background: none !important;
}

.btn_disabled {
    opacity: .5 !important;
}

.form__content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.open_assets {
    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2 !important;
}

.alerts__input__wrapper {
    position: relative;
}

* {
    scrollbar-width: none !important;
    /* Firefox implementation */
}

.delete_module {
    height: 260px;
}

.delete_module .title {
    font-size: 19px;
    font-weight: 600;
    color: #364048;
    text-align: center;
    display: flex;
    justify-content: center;
    margin: 0 auto;
}

.delete_module .btn_content {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.delete_module .card__product__stake__amount__confirm {
    width: 40%;
}

.save__text {
    height: 100%;
    width: 100%;
    background: none;
    border: none;
    cursor: pointer;
}

.card__wallet__content {
    display: flex;
    justify-content: flex-start;
}

.ReactModal__Content .ReactModal__Content--after-open {
    padding: 0 !important;
}

.wallet__modal__container {
    padding-top: 105px;
}

.balance__block__top {
    cursor: auto !important;
}

.ntf_card_title {
    display: flex;
    margin: auto;
}


.delete_module .title__name {
    font-weight: 900;
}

.empty_main {
    border-color: #f0f0f3 !important;
    color: #C4C4C4 !important;
}

.open__modal {
    top: 388px !important;
}

.add__wallet__btn__plus__bg {
    margin: auto;
}


.card__round__shadow__defi__list {
    width: 55px;
    height: 53px;
    position: absolute;
    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;
    border-radius: 50%;
    top: 23px;
    left: 23px;
}

.password__change__label {
    position: relative;
    padding: 0 20px !important;
    text-align: start !important;
    align-items: flex-start !important;
}

.password__input {
    border: none;
    width: calc(100% - 50px);
    outline: none;
    font-size: 18px;
    line-height: 25px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    background: none;
}


.success_message {
    text-align: center;
    font-size: 18px;
    line-height: 26px;
    color: #214175;
    display: flex;
    justify-content: center;
    margin: 3px 0 5px 0;
    line-break: anywhere;
    font-weight: 600;
}

.card__product__green {
    color: #4DC7B5 !important;
}


.card__product__yellow {
    color: #EFB661 !important;
}

.card__product__red {
    color: #F27281 !important;
}

.card__product__white {
    color: #9CA3A8 !important;
}


.card__border__color__green {
    border-color: #4DC7B5 !important;
}

.card__border__color__yellow {
    border-color: #EFB661 !important;
}

.card__border__color__red {
    border-color: #F27281 !important;
}

.card__border__color__white {
    border-color: #9CA3A8 !important;
}


.aside__nth__title {
    font-size: 14px !important;
    line-height: 20px !important;

}

.user__info__name {
    border: none;
    background: none;
    outline: none;
}

.user__avatar {
    object-fit: cover;
}

.qr__opacity {
    opacity: 0 !important;
}

.uploda__user__image {
    width: 18px;
    height: 18px;
    margin-right: 8px
}

.qr__logo__opacity {
    opacity: 0 !important;
    display: none !important;
}

.user__name {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 60px;
    white-space: nowrap;
}

.forgot__password__content {
    width: 285px;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.forgot__passwors_text {
    cursor: pointer;
    font-weight: 500;
    line-height: 15px;
    font-size: 15px;
    color: #214175;
}

.clean__all {
    cursor: pointer;
    font-weight: 500;
    line-height: 15px;
    font-size: 15px;
    color: #214175;
    width: 200px;
    padding: 10px;
    margin-bottom: 21px;
}


.trash__delete__modal__content .card__product__stake__amount {
    left: 0;
    right: 0;
    margin: auto;
}


.approve_btn {
    margin: auto;
    justify-content: center !important;
}

.approves__modal {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    z-index: 9;
    position: absolute;
}

.requests__message {
    word-break: break-all;
    width: 85%;
    margin: 3px auto !important;
}

.login_requests__message {
    word-break: break-all;
    width: 65%;
    margin: 3px auto !important;
}

.psw_requests__message {
    word-break: break-all;
    width: 60%;
    margin: 3px auto !important;
    display: flex;
    justify-content: center;
}

.light__defi__zoom {
    position: absolute !important;
    left: 0 !important;
    right: 24px !important;
}

.PhoneInputInput {
    width: 100% !important;
    background-color: transparent !important;
    border: 0 !important;
    outline: none !important;
    font-size: 18px !important;
    line-height: 23px !important;
    transition: all 0.4s !important;
}

.PhoneInput {
    padding: 0 10px !important;
}


.settings_error_message {
    text-align: center;
    font-size: 13px;
    line-height: 23px;
    color: #be6161;
    display: flex;
    margin: 3px 0 5px 0;
    justify-content: center;
}


.view__icon {
    width: 18px;
    height: 18px;
    cursor: pointer;
    right: 10px;
    position: absolute;
}

.notificaten__password__content {
    position: relative;
    align-items: center;
    text-align: center;
    justify-content: center;

}

.notificaten__password__icon {
    position: absolute;
    right: 6px;
    align-items: center;
    text-align: center;
    justify-content: center;
    display: flex;
    margin: auto;
    top: 15px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.email__title {
    width: 380px;
}

.trash__error__modal,
.unstake__error__modal {
    width: 300px;
    min-height: 200px;
    height: fit-content;
    position: fixed;
    z-index: 99999999;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #F0F0F3;
    box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgb(174 174 192 / 40%);
    border-radius: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;

}


.unstake__error__modal {
    width: 303px;
    left: -19px;
}

.trash__error__modal__title,
.unstake__error__modal__title {
    font-size: 16px;
    line-height: 21px;
    width: 300px;
    word-break: break-all;
    padding: 0 10px;
    color: #364048;
    font-weight: 600;
}

.unstake__error__modal__title {
    width: unset;
}

.alert__midal {
    left: 0;
}

.trash__title__item {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 90px;
    height: 1.2em;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: center;
    margin: auto 0px;
}



.trash__zoom {
    top: 70px !important;
    right: 60px !important;
    position: absolute !important;
}

.close__card__content {
    position: absolute;
    right: 15px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 30px;
    width: 30px;
    z-index: 999;
}

.form__content__error {
    margin-bottom: 0 !important;
}


.password__message {
    width: 85%;
}

.accept_password__message {
    width: 75%;
    margin: 15px 0 !important;
}

.change_password__message {
    width: 79%;
}

.version__title {
    margin: 10px 20px;
}

.defi__card__unstake {
    word-break: unset !important;
}

.active__page__main__container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
}

.active__page__main {
    background: #F0F0F3;
    box-shadow: -10px -10px 30px #ffffff, 10px 10px 30px rgb(174 174 192 / 40%);
    border-radius: 30px;
    width: 60%;
    padding: 20px 10px;
    position: relative;
}

.active_loading__layer {
    position: unset !important;
    width: unset !important;
    height: unset !important;
}

.alerts__input__wrapper div {
    display: flex !important;
    align-items: center !important;
}

.listing_error_message,
.error_message {
    color: rgb(190, 97, 97) !important;
    align-items: center;
    text-align: center;
    display: flex;
    font-size: 14px;
    justify-content: center;
    font-weight: 500;
}

.listing_error_message {
    font-size: 18px;
    margin-bottom: 10px;
}

.light_defi_row {
    justify-content: center !important;
    align-items: center !important;

}


.card__nft__wrapper_content {
    justify-content: start !important;
    width: 100%;
    max-height: 200px;
    overflow: auto;
    min-height: auto
}

.light_ntf_item_content {
    width: 100%;
    padding: 10px;
}

.light_ntf_item {
    padding: 5px;
    cursor: pointer;
    color: #717679;
    font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 3px;
}

.light_ntf_item:hover {
    color: #1762A2 !important;
}

.card__nft__wrapper_content::-webkit-scrollbar {
    background-color: none !important;
    width: 0 !important;
}

.light_ntf_item_img {
    height: 20px;
    width: 20px;
    border-radius: 50px;
}

.light_ntf_item_span {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100px;
    height: 1.2em;
    white-space: nowrap;
}

.wallet__close__card {
    z-index: 9 !important;
    height: 15px;
}

.wallet__form__header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;

}

.card__wallet__rates_input {
    border: none;
    background: none;
    outline: none;
    color: #889096;
    line-height: 26px;
    font-size: 14px;
    font-weight: 600;
}


.trash__card__title {
    margin: 0 !important;
}

.trash__card__row {
    margin-bottom: 8px !important;
}

.card__product__stake__block__light_defi {
    opacity: 0 !important;
}

.alert__input__modal {
    width: 300px;
    min-height: 200px;
    height: fit-content;
    position: absolute;
    z-index: 99999999;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #F0F0F3;
    box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgb(174 174 192 / 40%);
    border-radius: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;

    flex-direction: column;
}

.alert_btn_content {
    display: flex;
    width: 70%;
    justify-content: space-between;
    align-items: center;
}


.filter__icon {
    margin-right: -8px;
    cursor: pointer;
}

.chart__container {
    position: fixed;
    z-index: 999999;
    width: fit-content;
    height: fit-content;
    display: flex;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}

.wallet__add {
    width: 32px !important;
    height: 32px !important;
    position: absolute !important;
    top: 10px !important;
    left: 10px !important;
}

.adderss_input {
    width: 100% !important;
    font-size: 17px !important;

}

.wallet__address__container {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.address_input__wrapper {
    width: 100% !important;
    margin-bottom: 6px !important;
    padding: 0 23px 0 50px;
    font-size: 17px !important;

}

.wallet_address_content {
    position: relative;
    width: 96%;
    margin-left: 60px;
}

.addresses_items {
    display: flex;
    flex-direction: column;
    width: 100% !important;
}

.recucle__zoom_btn {
    margin-right: -45px !important;
}


.empty__trash_container .main:after {
    content: none !important;
    height: none !important;
}

.empty__trash_container .main .content {
    width: 100% !important;
}

.asset__list_filter {
    font-weight: 700 !important;
}

.WhitelistForm__container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.alerts__input__wrapper__container {
    align-items: center;
    text-align: center;
    width: 370px;
    margin-bottom: 20px;
}

.light_ntf_item_information {
    display: flex;
    align-items: center;
}

.light_ntf_item_span {
    margin-left: 10px;
}

.chart__card__title {
    margin: 0 0 17px 0 !important;
    font-size: 17px !important;
}

.trash .card__product__title {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 90px;
    white-space: nowrap;
}

.ntf__filter__content {
    width: 100%;
    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);
    border-radius: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    margin-bottom: 5px;
}

.ntf__filter__input {
    border: none;
    background: none;
    outline: none;
    font-size: 12px;
    line-height: 23px;
    font-weight: 500;
    color: #889096 !important;
    width: 100%;
    padding: 0 5px;
}

.light_ntf_item_isExist {
    background: #88909644 !important;
    border-radius: 24px !important;
}


.contract__address_main_content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}

.contract__address_btn {
    width: 100px !important;
    font-size: 14px !important;
    height: 35px !important;
}

.contract__address_content {
    height: 35px;
    width: 500px;
}

.chart__catent__value {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: auto;
}

.all_conections_ntf {
    width: 130px;
}


.page__loading__layer {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    z-index: 999 !important;
}


.unstake__error_message {
    color: rgb(190, 97, 97);
    align-items: center;
    text-align: center;
    display: flex;
    font-size: 13px;
    justify-content: center;
    font-weight: 600;
    line-height: 15px;
    padding: 0 1pc;
}

.email__input__add {
    width: 280px !important;
    margin: 0 auto;
}

.line__chart {
    padding: 0 10px;
}

.limit__block__wrapper_container {
    position: relative;
}

.walletShildAccept {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    padding: 16px;
    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);
    border-radius: 16px;
    background-color: #f0f0f3;
    width: 540px;
    margin-top: 5px;
}

.wallet_accept__type__save {
    width: 100%;
    height: 32px;
    border-radius: 67px;
    box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgb(174 174 192 / 40%);
    background-color: #214175;
    font-size: 15px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    border: 0;
}

.wallet_input_form {
    display: flex;
    flex-direction: column;
}

.wallet_input_form_title {
    text-decoration: none;
    color: #9CA3A8;
    font-weight: 600;
    font-size: 14px;
    border: none;
    outline: none;
    line-height: 23px;
    margin-bottom: 5px;
}

.wallet_input_form_input {
    border: none;
    outline: none;
    transition: all 0.4s;
    height: 40px;
    background: #F0F0F3;
    border-radius: 67px;
    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);
    display: flex;
    align-items: center;
    width: 100px;
    text-align: center;
    color: #9CA3A8;
    font-weight: 400;
    font-size: 13px;
}

.wallet_input_form_container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    width: 400px;
    margin: 0 auto 15px;
}

.assets__wallet__type {
    position: absolute !important;
    z-index: 99;
}

.wallet__shild__card__header {
    align-items: center;
    justify-content: center;
    display: flex;
}


.rangeslider-vertical .rangeslider__handle {
    outline: none !important;
}

.rangeslider-horizontal .rangeslider__handle {
    outline: none !important;
}

.whitelist__close__card {
    top: 0 !important;
    right: 6px !important;
}



.open__trush {
    left: 28px !important;
    width: 210px !important;
}

.wallet__addresses__top__right {
    display: flex;
    justify-content: flex-end;
}

.wallet__first__type {
    top: 0;
}

.wallet__modal {
    padding: 0 24px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.wallet__remove {
    font-size: 47px;
    display: flex;
    margin-top: -12px;
    color: #2167A4;
}

.partner_img_item {
    object-fit: contain !important;
}


.partner__guard__title {
    font-size: 13px;
}


.selected__item {
    color: #214175 !important;
    font-size: 19px !important;
    font-weight: 700 !important;
}

.hours_title {
    margin-left: 5px;
}


.risk__text {
    color: #889096;
    font-weight: 600;
    font-size: 14px;
    position: absolute;
    margin: 7px 0;
    line-height: 18px;
    font-family: sans-serif;
}

.heder_title {
    font-weight: bold;
}

.input-box {
    display: flex;
    overflow: hidden;
    font-family: sans-serif;
    width: 100%;
    height: 100%;
}

.flex_input {
    flex-grow: 1;
    max-width: 60%;
    outline: none;
    border: none;
    background: none;
    color: #4DC7B5;
    font-weight: 600;
    font-size: 18px;
}

.prefix {
    font-weight: 300;
    color: #4DC7B5;
    font-weight: 600;
    font-size: 18px;
    padding: 0 5px;
    width: max-content;
    height: fit-content;
}

.flex_input::placeholder {
    font-size: 14px;
    color: #4DC7B5;
}

.listening_main_wrapper {
    height: calc(100vh - 56px);
    padding-left: 72px;
    margin-left: 24px;
    margin-right: 24px;
    margin-top: 40px;
    background: #F0F0F3;
    /* width: 100%; */
    transition: padding-left 0.4s;
}

.listening_main_wrapper.open {
    padding-left: 325px;
}

.listening_tabs_main_wrapper {
    /* width: 960px; */
    width: 100%;
    height: 56px;
    /* display: flex; */
}

.listening_tabs_wrapper {
    display: flex
}

.listening_tab_wrapper {
    width: 240px;
    height: 56px;
    border-radius: 24px 24px 0px 0px;
    padding: 8px;
    background-color: #E8E8E8;
    margin-right: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.listening_tab_wrapper:last-child {
    margin-right: 0;
}

.listening_tab_wrapper:hover {
    background-color: white;
}

.listening_tab_text {
    font-family: Assistant;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    color: #364048
}

.active_tab>.listening_tab_text {
    font-weight: bold;

}

.listening_search_wrapper {
    display: flex;
    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);
    width: 226px;
    height: 32px;
    position: relative;
    border-radius: 24px;
}

.assets_search_wrapper {
    width: 315px;
    margin-bottom: 8px;
}

.listening_search_icon_wrapper {
    box-shadow: inset -5px -5px 5px 0px #FFFFFFBF, inset 5px 5px 5px 0px #AEAEC033;
    border-radius: 50%;
    height: 32px;
    width: 32px;
    display: flex;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    outline: none;
}

.listening_search_field {
    background: transparent;
    border: none;
    width: 100%;
    padding-left: 40px;
}

.listening_search_field:focus {
    outline: none;
}

.listing_search_row {
    /* width: 1768px; */
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 40px;
    margin-bottom: 24px;
}

.listing_export_customize_columns_wrapper {
    display: flex;
    /* margin-right: 16px; */
    gap: 20px;
}

.listing_export {
    cursor: pointer;
    width: 123px;
    height: 32px;
    padding: 4px 24px 4px 16px;
    gap: 8px;
    border-radius: 24px;
    border: 1px 0px 0px 0px;
    opacity: 0px;
    border: 1px solid #214175;
    font-family: Assistant;
    font-size: 18px;
    font-weight: 600;
    line-height: 23.54px;
    color: #214175;
}

.listing_export_icon {
    margin-right: 16px;
}

.listing_customize_icon {
    margin-right: 11px;
}

/* .listing_customize {
    cursor: pointer;

    padding-left: 16px;
    padding-right: 24px;
    height: 32px;
    width: 48px;
    gap: 8px;
    border-radius: 24px;
    opacity: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #214175;
    color: white;
    font-family: Assistant;
    font-size: 18px;
    font-weight: 600;
    line-height: 23.54px;
    text-align: left;
    margin-left: 16px;
    border: none
} */
.listing_customize {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    width: 60px;
    /* small initial width for icon */
    height: 32px;
    padding: 0 20px;
    background: transparent;
    color: #214175;
    border: 1px solid #214175;
    border-radius: 24px;
    cursor: pointer;
    transition: width 0.4s ease, background-color 0.3s ease, color 0.3s ease;
    gap: 12px;
}

/* Special styling for the first button */
.listing_customize:last-child {
    background-color: #214175;
    /* border: 1px solid #214175; */
    color: #ffffff;
}

.listing_customize:last-child:hover {
    background-color: #2267a4;
}

/* Hover for all buttons */
.listing_customize:hover {
    width: 110px;
    padding-right: 10px;
    border-color: #2267a4;
}

/* Hover for the first button only */
.listing_customize:first-child:hover {
    background-color: #ffffff;
    color: #2267a4;
    border-color: #2267a4;
}

/* Icon */
.listing_customize i {
    font-size: 18px;
    flex-shrink: 0;
    transition: transform 0.3s ease;
}

/* Text hidden by default */
.listing_customize span {
    opacity: 0;
    white-space: nowrap;
    transform: translateX(-20px);
    transition: opacity 0.3s ease, transform 0.3s ease;
}

/* Reveal text on hover */
.listing_customize:hover span {
    opacity: 1;
    transform: translateX(0);
    position: relative;
    right: 5px;
}

.listing_customize:hover .icon-export:before {
    content: "\\e900";
    color: #2267a4;
}

.listing_customize:hover .icon-customize:before {
    content: "\\e900";
    color: #2267a4;
}

.listing_customize:hover span {
    color: #2267a4;
}

.listing_customize:last-child:hover span {
    color: #fff;
}


.listing_customize_icon {
    content: "\\e900";
    color: #2267a4 !important;
}

/*Dropdown style*/
/* ---------------------------
   Dropdown button (no expand)
   --------------------------- */

/* Make dropdown button size based on content (no small-icon compact state) */
.listing_score_algorithm {
    width: auto !important;
    /* let content determine width */
    min-width: 120px;
    /* optional: ensure a reasonable minimum */
    padding: 0 14px;
    /* visible spacing */
    transition: none !important;
    /* disable width/color transitions */
    background: #214175;
    /* keep the same base BG as other buttons */
    color: #fff;
    border: none;
    /* switch to border if you prefer outline */
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

/* Ensure the span text is always visible (no hidden text) */
.listing_score_algorithm span {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
}

/* Prevent hover from changing width or hiding text */
.listing_score_algorithm:hover {
    width: auto !important;
    background-color: #2267A4;
    /* optional hover color */
}

/* If you used :first-child or other generic selectors earlier,
   make sure dropdown's visibility doesn't get overridden */
.listing_score_algorithm:first-child,
.listing_score_algorithm:focus,
.listing_score_algorithm.ant-dropdown-open {
    width: auto !important;
    min-width: 120px;
}

/* Optional: icon sizing and spacing */
.listing_score_algorithm i {
    font-size: 16px;
    flex-shrink: 0;
}


.listing_saveUs {
    border: 1px solid #214175;
    color: #214175;
    background-color: transparent;
    text-decoration: none;
}

.listing_score_algorithm {
    width: 200px;
    height: 32px;
    opacity: 1;
    border-radius: 24px;
    background: #F0F0F3;
    box-shadow: -8px -8px 24px 0px #FFFFFF;
    box-shadow: 4px 4px 8px 0px #AEAEC066;
    display: flex;
    justify-content: flex-start;
}

.listing_score_algorithm>span {
    font-family: Assistant;
    font-weight: 600;
    font-size: 16px;
    color: #364048;
    position: relative;
    z-index: 11;
}

/* Dropdown container */
.algorithm-dropdown-overlay {
    padding: 0 !important;
    border-radius: 0 0 8px 8px !important;
    overflow: hidden;
    background: #F0F0F3;
    box-shadow: 0px 12px 12px rgba(0, 0, 0, 0.15);
    will-change: transform, opacity;
    /* animation: dropdown-slide 0.25s ease forwards; */
    /* inset: 204px auto auto 1372px !important; */
    inset: 204px auto auto 1462px !important;
    width: 154px;
    z-index: 10;
}

.custom-tooltip-position {
    inset: 218px 366px auto auto !important;
}

/* Accordion-like slide down */
@keyframes dropdown-slide {
    from {
        opacity: 0;
        transform: translateY(-6px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Menu items container */
.algorithm-dropdown-menu {
    display: flex;
    flex-direction: column;
    min-width: 200px;
    margin-top: 20px;
}

/* Each item */
.algorithm-dropdown-item {
    padding: 8px 14px;
    cursor: pointer;
    font-size: 16px;
    font-family: Assistant;
    font-weight: 600;
    color: #364048;
    border-top: 1px solid #e5e5e5;
    transition: background 0.2s ease;
}

/* Remove bottom border on last item */
.algorithm-dropdown-item:last-child {
    border-bottom: none;
}

/* Hover + active styles */
.algorithm-dropdown-item:hover {
    background: #f5f7fa;
}

.algorithm-dropdown-item.active {
    background: #e4e6e9;
    font-weight: 600;
    /* color: #1677ff; */
}

.listing_modal_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 27px;
}

.listing_modal_title {
    font-family: Assistant;
    font-size: 22px;
    font-weight: 700;
    color: #364048;
}

.listing_modal_close_icon {
    height: 14px;
    width: 14px;
    margin-right: 32px;
    cursor: pointer
}

.listing_volumes_wrapper {
    width: 90%;
    height: 496px;
    overflow: auto;
}

.listing_single_volume_wrapper {
    display: flex;
    align-items: center;
    height: 48px;
    gap: 8px;
    cursor: pointer;
}

.listing_single_volume_checkbox {
    width: 18.67px;
    height: 18.67px;
    top: 6.67px;
    left: 6.67px;
    gap: 0px;
    border-radius: 1.33px 0px 0px 0px;
    border: 9.33px 0px 0px 0px;
    opacity: 0px;
    border: 9.33px solid #2267A4;
    margin-right: 14.67px;
    cursor: pointer;
}

.listing_volumes_divider {
    margin: 8px 0;
    border: 1px solid #D8D8E0
}

.listing_modal_submit {
    width: 138px;
    height: 32px;
    gap: 8px;
    border-radius: 24px;
    opacity: 0px;
    background: #214175;
    font-family: Assistant;
    font-size: 18px;
    font-weight: 600;
    line-height: 23.54px;
    text-align: left;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    cursor: pointer;
}

.listing_modal_submit_wrapper {
    display: flex;
    justify-content: flex-end;
    margin: 27px 40px 0 0;
}

.active_tab {
    box-shadow: -3px -3px 6px 0px rgba(255, 255, 255, 1), 3px -6px 6px 0px rgba(174, 174, 192, 0.4);
    background-color: #F0F0F3;
}

.listing_content_wrapper {
    /* width: 1768px; */
    width: 100%;
    background-color: #F0F0F3;
    box-shadow: -8px -8px 24px 0px #FFFFFF, 8px 8px 24px 0px #AEAEC066;
    padding-top: 32px;
    border-radius: 0 24px 24px 24px;
    background-color: #F0F0F3;
}

.listing_asset_modal_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 37px;
}

.listing_asset_modal_title {
    font-family: Assistant;
    font-size: 22px;
    font-weight: 700;
    text-align: left;
}

.listing_asset_modal_money_field {
    width: 475px;
    height: 32px;
    border-radius: 24px;
    background-color: #F0F0F3;
    box-shadow: inset -5px -5px 5px 0px rgba(255, 255, 255, 0.75), inset 5px 5px 5px 0px rgba(174, 174, 192, 0.2);
    border: none;
    padding-left: 16px;
    font-size: 18px;
}

.listing_asset_modal_money_field_wrapper {
    margin-bottom: 30px;
}

.listing_change_alert_wrapper {
    display: flex;
    align-items: center;
}

.listing_change_alert_checkbox {
    width: 18.67px;
    height: 18.67px;
    border-radius: 1.33px;
    border: 9.33px;
    margin-right: 15px;
}

.listing_change_alert_text {
    font-family: Assistant;
    font-size: 18px;
    font-weight: 600;
    line-height: 23.54px;
}

.listing_change_enter_your_details {
    font-family: Assistant;
    font-size: 18px;
    font-weight: 500;
    line-height: 23.54px;
}


.listing_table_wrapper {
    height: 70vh;
    /* height: 580px; */
    /* width: 1768px; */
    margin-bottom: 50px;
    width: 100%;
    overflow: auto;
    -webkit-user-select: none;
    user-select: none;
}

.listing_table {
    border-radius: 24px;
    min-width: max-content;
    /* margin-top: 61px; */
}

.listing_table_row_wrapper {
    display: block;
    padding: 18px 0px;
    border-top: 1px solid #D8D8E0;
    border-bottom: 1px solid #D8D8E0;
    min-width: 1768px;
}

.hover:hover {
    background-color: #D8D8E0;
}

.hover:hover .headcol {
    background-color: #D8D8E0;
}

.highlighted_row {
    background-color: #E9E9EC;
}

.highlighted_row td {
    font-family: Assistant;
    font-weight: 700;
    font-size: 18px;
    line-height: 23.54px;
    color: #364048;
}

.highlighted_row td span {
    padding-left: 55px;
}

.listing_table_first_column,
.listing_table_titles,
.listing_table_datas {
    width: 202px;
    font-family: Assistant;
    font-size: 18px;
    line-height: 23.54px;
    text-align: left;
    color: rgba(54, 64, 72, 1);
    position: relative;
    /* z-index: 1; */
    padding-left: 20px;
}

.listing_table_titles {
    font-weight: 700;
    /* color: rgba(136, 144, 150, 1); */
    color: #364048;
}

.listing_table_yes,
.listing_table_no {
    font-family: Assistant;
    font-size: 18px;
    font-weight: 700;
    line-height: 23.54px;
}

.listing_table_yes {
    color: rgba(77, 199, 181, 1);
}

.listing_bolded_row {
    font-weight: bold;
    text-transform: capitalize;
}

.listing_table_no {
    color: rgba(245, 180, 82, 1);
}

.listing_asset_edit_value {
    font-size: 16px;
    font-weight: bold;
    padding-left: 8px !important;
    color: #364048;

}

.listing_asset_edit_icon {
    height: 12px;
    width: 12px;

    cursor: pointer;
    margin-left: 7px;
}

.listing_asset_edit {
    display: inline-block;
    margin-left: 5px;
    box-sizing: border-box;
    cursor: pointer;
    position: absolute;
    /* right: 35px; */
}

.listing_asset_edit:hover {
    background-color: rgba(34, 103, 164, 0.2);
    border-radius: 4px;
    width: 24px;
    /* padding: 3px 0; */
    box-sizing: border-box;
}

.listing_asset_edit_icon:hover>path {
    fill: #2267A4;

}

.listing_asset_modal_money_field::-webkit-outer-spin-button,
.listing_asset_modal_money_field::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.listing_filter_volums_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    width: 24px;
    margin-left: 8px;
    cursor: pointer
}

.listing_filter_volums_wrapper:hover {
    border-radius: 5px;
    background-color: #C7D5E3
}

.listing_filter_volums {
    height: 12px;
    width: 12px;
}

.assetRowWrapper {
    display: flex;
    align-items: center;
}


table {
    border-collapse: separate;
    border-spacing: 0;
    /* border-top: 1px solid grey; */
}


.headcol {
    position: sticky !important;
    z-index: 2;
    left: 0;
    top: auto;
    background-color: #f0f0f3;

    /*border-top-width: 1px;    
     
    margin-top: -1px;
    padding: 18px 40px; */
    /*compensate for top border*/
}

/* .headcol>span{
    position:fixed;
  } */
.headcol::after {
    position: absolute;
    top: -18px;
    right: 0;
    bottom: -30px;
    width: 23px;
    /* transform: translateX(100%); */
    box-shadow: 8px 0 16px -7px rgba(174, 174, 192, 0.4);
    content: "";
    pointer-events: none;
}

.headrow {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f0f0f3;
    width: 93%;
    margin-top: -1px
}

.headcol span {
    padding-left: 40px;
    max-width: 100%;
    display: inline-block;
    white-space: nowrap;
}

.PhoneInputInput {
    text-align: center;
    margin-right: 35px;
}

.error__message {
    white-space: nowrap;
}

.password__message {
    white-space: break-spaces;
}

.ant-tooltip .ant-tooltip-content {
    width: 429px;
}

.security-tooltip .ant-tooltip-content {
    width: 720px;
}

.custom-toolTip p,
.custom-toolTip h2 {
    padding-bottom: 12px;
}

.security-tooltip p,
.security-tooltip h2 {
    padding-bottom: 10px;
}

.custom-toolTip {
    padding: 15px;
    overflow: auto;
}

::placeholder {
    color: #949ba0;
}

.generalText {
    width: 200px;
    /* word-break: break-all; */
    white-space: normal;
    overflow-wrap: break-word;
    /* hyphens: auto; */
    font-family: Assistant;
    font-size: 18px;
    line-height: 23.54px;
    text-align: left;
    color: rgba(54, 64, 72, 1);
}

.deleteImage {
    position: absolute;
    top: 25px;
    z-index: 10;
    right: 40px;
}

.accordionArrow {
    width: 8px;
    position: relative;
    left: 40px;
    vertical-align: inherit;
    transition: transform 0.3s ease;
}

.accordionArrowRotate {
    transform: rotate(90deg);
    width: 8px;
    position: relative;
    left: 40px;
    vertical-align: inherit;
    transition: transform 0.3s ease;
}

.alertIconClicked.icon-alert:before {
    background: #2267A4;
    vertical-align: text-top;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    color: #C7D5E3 !important;
    justify-content: center;
    align-items: center;
}

.ant-notification-notice-wrapper {
    border-left: 5px solid #2267A4;
    height: 65px;
    border-radius: 5px;
}



.zoom__page .add_staking {
    top: 48% !important;
}


.tooltip .rangeslider__handle-tooltip {
    left: 100%;
    /* push to right of the slider */
    margin-left: 15px;
    /* add some spacing */
    top: 50%;
    transform: translateY(-50%);

}

@media (max-width: 1920px) {
    .add_staking {
        top: 43% !important;
    }
}

@media (max-width: 1320px) {

    .listing_table_wrapper {
        height: 68vh;
    }
}

.zoom__page .sr-right-header {
    width: 58% !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT;;kBAEc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;iBACa;AACjB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,2GAA2G;AAC/G;;;AAGA,SAAS;;AAET;IACI,qBAAqB;IACrB,wBAAwB;IACxB,2GAA2G;IAC3G,8BAA8B;IAC9B,8BAA8B;IAC9B,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;IAC7B,wGAAwG;AAC5G;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,6EAA6E;IAC7E,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,6BAA6B;IAC7B,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;;IAEI,4DAA4D;IAC5D,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,iFAAiF;IACjF,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,kDAAkD;IAClD,uCAAuC;IACvC,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,mEAAmE;IACnE,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,6FAA6F;AACjG;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;;AAGA,mDAAmD;AACnD;;IAEI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;;;;;;;;;;;;;;;sBAekB;;IAElB,0BAA0B;IAC1B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,iCAAiC;IACjC,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,iCAAiC;IACjC,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,2CAA2C;IAC3C;kBACc;AAClB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0DAA0D;IAC1D,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0DAA0D;IAC1D,kBAAkB;AACtB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;;IAEI,4EAAoE;IAApE,oEAAoE;AACxE;;AAEA,SAAS;;;AAGT;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0DAA0D;IAC1D,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;;AAGA;IACI,0BAA0B;IAC1B,4BAA4B;;AAEhC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,wCAAwC;IACxC,oBAAoB;IACpB,wBAAwB;IACxB,0BAA0B;IAC1B,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;;AAE3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,uEAAuE;IACvE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;;AAE3B;;;AAGA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;;;AAIA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,2EAA2E;IAC3E,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;;IAEI,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;;AAElC;;;AAGA;IACI,iCAAiC;IACjC,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,uEAAuE;IACvE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;;IAEvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;;AAE9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;IACtB,0BAA0B;;AAE9B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gGAAgG;IAChG,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;AAC3B;;;AAGA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,gGAAgG;IAChG,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,wEAAwE;IACxE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,gGAAgG;IAChG,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;;;AAIA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,eAAe;AACnB;;;AAGA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,gGAAgG;IAChG,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,8EAA8E;IAC9E,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,yDAAgD;IAChD,4BAA4B;IAC5B,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,QAAQ;IACR,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;GAsBG;AACH;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,iCAAiC;IACjC,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,wEAAwE;IACxE,SAAS;AACb;;AAEA,yCAAyC;AACzC;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,oCAAoC;AACpC;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA,SAAS;AACT;IACI,eAAe;IACf,cAAc;IACd,+BAA+B;AACnC;;AAEA,2BAA2B;AAC3B;IACI,UAAU;IACV,mBAAmB;IACnB,4BAA4B;IAC5B,kDAAkD;AACtD;;AAEA,yBAAyB;AACzB;IACI,UAAU;IACV,wBAAwB;IACxB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;;gCAEgC;;AAEhC,6EAA6E;AAC7E;IACI,sBAAsB;IACtB,gCAAgC;IAChC,gBAAgB;IAChB,0CAA0C;IAC1C,eAAe;IACf,oBAAoB;IACpB,2BAA2B;IAC3B,oCAAoC;IACpC,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,4DAA4D;AAC5D;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,qDAAqD;AACrD;IACI,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;2DAC2D;AAC3D;;;IAGI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI,eAAe;IACf,cAAc;AAClB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,sCAAsC;IACtC,qCAAqC;IACrC,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,qBAAqB;IACrB,qCAAqC;IACrC,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,+BAA+B;IAC/B,mDAAmD;IACnD,8CAA8C;IAC9C,wCAAwC;IACxC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,8BAA8B;AAC9B;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA,sCAAsC;AACtC;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,iCAAiC;IACjC,0BAA0B;IAC1B,YAAY;IACZ,4BAA4B;IAC5B,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+FAA+F;IAC/F,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,kEAAkE;IAClE,iBAAiB;IACjB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,6GAA6G;IAC7G,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;;AAGA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,yBAAyB;IAGzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,cAAc;AAClB;;AAEA;;IAEI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,cAAc;;AAElB;;AAEA;IACI,YAAY;IACZ,WAAW;;IAEX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;;AAEjB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gCAAgC;AACpC;;;AAGA;IACI,2BAA2B;IAC3B,UAAU;IACV,OAAO;IACP,SAAS;IACT,yBAAyB;;IAEzB;;;yBAGqB;IACrB,4BAA4B;AAChC;;AAEA;;KAEK;AACL;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,aAAa;IACb,WAAW;IACX,iCAAiC;IACjC,oDAAoD;IACpD,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;AACtB;;;;AAIA;IACI,mBAAmB;AACvB;;;AAGA;IACI,UAAU;IACV,gCAAgC;IAChC,iBAAiB;IACjB,qBAAqB;IACrB,QAAQ;IACR,2BAA2B;;AAE/B;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["body {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n        sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\nbody.no-scroll {\n    overflow: hidden;\n}\n\n.no-cursor {\n    cursor: none;\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n        monospace;\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nhtml {\n    scroll-behavior: smooth;\n}\n\nbody {\n    overflow: hidden;\n}\n\n.ReactModal__Overlay {\n    background: #00000040 !important;\n    z-index: 11 !important;\n}\n\n.card__product__stake_active {\n    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;\n}\n\n\n/*range */\n\n.rangeslider-vertical {\n    width: 8px !important;\n    height: 176px !important;\n    box-shadow: inset 3px 3px 3px rgb(174 174 192 / 20%), inset -3px -3px 3px rgb(255 255 255 / 70%) !important;\n    border-radius: 88px !important;\n    background: #F0F0F3 !important;\n    left: 5px !important;\n    top: 0 !important;\n    margin: 0 !important;\n}\n\n.rangeslider {\n    margin: 2px 0 !important;\n}\n\n.rangeslider-vertical .rangeslider__handle-label {\n\n    width: 16px !important;\n    display: flex !important;\n    height: 16px !important;\n    border-radius: 50% !important;\n    box-shadow: inset 2px 2px 2px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%) !important;\n}\n\n.card__slider .rangeslider-vertical .rangeslider__handle-label {\n    background: #F27281 !important;\n}\n\n.rangeslider-vertical .rangeslider__handle {\n    width: 27px !important;\n    height: 27px !important;\n    background: #F0F0F3;\n    box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px rgb(54 54 77 / 40%) !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    border-radius: 50% !important;\n    position: absolute !important;\n    left: -9px !important;\n    cursor: pointer !important;\n}\n\n.rangeslider-vertical .rangeslider__fill {\n\n    box-shadow: inset 3px 3px 3px rgb(64 64 80 / 33%) !important;\n    border-radius: 0px 0px 20px 20px !important;\n}\n\n.card__slider .rangeslider-vertical .rangeslider__fill {\n    background: #F27281 !important;\n}\n\n.rangeslider__labels {\n    display: none;\n}\n\n.rangeslider-horizontal {\n    width: 105px !important;\n    height: 8px !important;\n    box-shadow: inset 3px 3px 3px #aeaec033, inset -3px -3px 3px #ffffffb2 !important;\n    border-radius: 88px !important;\n    background: #F0F0F3 !important;\n}\n\n.rangeslider-horizontal .rangeslider__fill {\n    height: 100% !important;\n    background: #F27281 !important;\n    box-shadow: inset 3px 3px 3px #40405053 !important;\n    border-radius: 20px 0 0 20px !important;\n    position: absolute !important;\n    left: 0 !important;\n}\n\n.rangeslider-horizontal .rangeslider__handle {\n    width: 24px !important;\n    height: 24px !important;\n    background: #F0F0F3 !important;\n    box-shadow: -2px -2px 6px #ffffff, 2px 2px 6px #36364d67 !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    border-radius: 50% !important;\n    cursor: pointer !important;\n}\n\n.rangeslider-horizontal .rangeslider__handle-label {\n    background: #F27281;\n    width: 16px;\n    display: flex;\n    height: 16px;\n    border-radius: 50%;\n    box-shadow: inset 2px 2px 2px rgb(54 54 70 / 60%), inset -2px -2px 2px rgb(255 255 255 / 60%);\n}\n\n.rangeslider__handle::after {\n    display: none !important;\n}\n\n.current__card .rangeslider-horizontal {\n    width: 105px;\n}\n\n\n/* CUSTOM CSS TO CENTER PERCENTAGE IN PROGRESSBAR */\n.card__risk__chart__min__wrapper,\n.card__risk__chart__min__wrapper_aside {\n    position: absolute;\n    top: 60%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-align: center;\n}\n\n.card__risk__chart__min__wrapper__defi__list {\n    top: 50% !important;\n}\n\n.card__risk__chart__min__wrapper_aside {\n    top: 35% !important;\n}\n\n.qr__logo {\n    width: 100px;\n    height: 100px;\n    opacity: 1;\n    display: flex;\n    margin: 0 auto 20px;\n}\n\n.selected__type {\n    border: 1px solid red;\n}\n\n\ninput[type=\"file\"] {\n    display: none;\n    cursor: pointer;\n}\n\n.avatarActions {\n    display: none;\n}\n\n.user__info__avatar__wrapper:hover .avatarActions {\n    display: block;\n}\n\n.upload__content {\n    display: flex;\n    flex-direction: row;\n}\n\n.upload__content {\n    /* width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border-radius: 50%;\n    box-shadow: -8px -8px 15px #ffffff, 8px 8px 15px #aeaec067;\n    z-index: 2;\n    background: transparent radial-gradient(closest-side at 50% 50%, #69686F00 0%, #6A697180 94%, #727179 100%) 0 0 no-repeat padding-box;\n    opacity: 0;\n    align-items: center;\n    color: white;\n    justify-content: center;\n    font-size: 18px;\n    font-weight: 600;\n    cursor: pointer; */\n\n    padding: 2px 24px 2px 21px;\n    position: absolute;\n    top: 37%;\n    left: 25%;\n    border-radius: 24px;\n    z-index: 2;\n    background: rgba(54, 64, 72, 0.5);\n    opacity: 1;\n    align-items: center;\n    color: white;\n    justify-content: center;\n    /* font-size: 18px; */\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.upload__content:hover {\n\n    background: #364048;\n}\n\n.deleteArea:hover {\n    background: #364048;\n}\n\n.deleteArea {\n    padding: 3px 19px 2px 22px;\n    position: absolute;\n    top: 50%;\n    left: 25%;\n    border-radius: 24px;\n    z-index: 2;\n    background: rgba(54, 64, 72, 0.5);\n    opacity: 1;\n    align-items: center;\n    color: white;\n    justify-content: center;\n    /* font-size: 18px; */\n    font-weight: 600;\n    cursor: pointer;\n\n}\n\n.user__info__avatar__block:hover {\n    background-color: rgba(105, 104, 111, 0.82);\n    /* position: absolute;\n    z-index: 10; */\n}\n\n.upload_title {\n    cursor: pointer;\n    /* margin-left:4px; */\n}\n\n.round__shdow {\n    width: 168px;\n    height: 168px;\n    position: absolute;\n    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;\n    border-radius: 50%;\n}\n\n.card__round__shadow {\n    width: 100px;\n    height: 100px;\n    position: absolute;\n    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;\n    border-radius: 50%;\n}\n\n\n.main.main_setting::after {\n    display: none;\n}\n\n.main.empty__trash::after {\n    display: none;\n}\n\n\n.card__slider_not_value .rangeslider-vertical .rangeslider__handle-label {\n    background: #E3E2E2 !important;\n}\n\n.card__slider_not_value .rangeslider-vertical .rangeslider__fill {\n    background: #E3E2E2 !important;\n}\n\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:focus {\n    transition: background-color 600000s 0s, color 600000s 0s !important;\n}\n\n/* open */\n\n\n.nav.open {\n    width: 272px;\n}\n\n.nav.open .logo {\n    width: 200px;\n}\n\n.nav.open .logo__img {\n    display: none;\n}\n\n.nav.open .logo__img__big {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n}\n\n.nav.open .nav__link {\n    width: 208px;\n}\n\n.nav.open .nav__link .nav__text {\n    font-size: 20px;\n    position: relative;\n    opacity: 1;\n    visibility: visible;\n    color: #364048;\n}\n\n.main.open {\n    padding-left: 325px;\n}\n\n.header.open {\n    padding-left: 296px;\n}\n\n\n.horizontal_slid_nit_value .rangeslider-horizontal .rangeslider__handle-label {\n    background: #E3E2E2 !important;\n}\n\n.card__risk__alert__not_number {\n    color: #889096 !important;\n}\n\n.css-1s2u09g-control {\n    border: none !important;\n    background: none !important;\n    cursor: pointer !important;\n}\n\n.css-1okebmr-indicatorSeparator {\n    background: none !important;\n}\n\n.css-2613qy-menu {\n    background: none !important;\n}\n\n.btn_disabled {\n    opacity: .5 !important;\n}\n\n.form__content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.open_assets {\n    box-shadow: inset 10px 10px 10px #AEAEC033, inset -10px -10px 10px #FFFFFFB2 !important;\n}\n\n.alerts__input__wrapper {\n    position: relative;\n}\n\n* {\n    scrollbar-width: none !important;\n    /* Firefox implementation */\n}\n\n.delete_module {\n    height: 260px;\n}\n\n.delete_module .title {\n    font-size: 19px;\n    font-weight: 600;\n    color: #364048;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    margin: 0 auto;\n}\n\n.delete_module .btn_content {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.delete_module .card__product__stake__amount__confirm {\n    width: 40%;\n}\n\n.save__text {\n    height: 100%;\n    width: 100%;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.card__wallet__content {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.ReactModal__Content .ReactModal__Content--after-open {\n    padding: 0 !important;\n}\n\n.wallet__modal__container {\n    padding-top: 105px;\n}\n\n.balance__block__top {\n    cursor: auto !important;\n}\n\n.ntf_card_title {\n    display: flex;\n    margin: auto;\n}\n\n\n.delete_module .title__name {\n    font-weight: 900;\n}\n\n.empty_main {\n    border-color: #f0f0f3 !important;\n    color: #C4C4C4 !important;\n}\n\n.open__modal {\n    top: 388px !important;\n}\n\n.add__wallet__btn__plus__bg {\n    margin: auto;\n}\n\n\n.card__round__shadow__defi__list {\n    width: 55px;\n    height: 53px;\n    position: absolute;\n    box-shadow: inset 0 3px 6px #00000029, 0 3px 6px #00000029;\n    border-radius: 50%;\n    top: 23px;\n    left: 23px;\n}\n\n.password__change__label {\n    position: relative;\n    padding: 0 20px !important;\n    text-align: start !important;\n    align-items: flex-start !important;\n}\n\n.password__input {\n    border: none;\n    width: calc(100% - 50px);\n    outline: none;\n    font-size: 18px;\n    line-height: 25px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    background: none;\n}\n\n\n.success_message {\n    text-align: center;\n    font-size: 18px;\n    line-height: 26px;\n    color: #214175;\n    display: flex;\n    justify-content: center;\n    margin: 3px 0 5px 0;\n    line-break: anywhere;\n    font-weight: 600;\n}\n\n.card__product__green {\n    color: #4DC7B5 !important;\n}\n\n\n.card__product__yellow {\n    color: #EFB661 !important;\n}\n\n.card__product__red {\n    color: #F27281 !important;\n}\n\n.card__product__white {\n    color: #9CA3A8 !important;\n}\n\n\n.card__border__color__green {\n    border-color: #4DC7B5 !important;\n}\n\n.card__border__color__yellow {\n    border-color: #EFB661 !important;\n}\n\n.card__border__color__red {\n    border-color: #F27281 !important;\n}\n\n.card__border__color__white {\n    border-color: #9CA3A8 !important;\n}\n\n\n.aside__nth__title {\n    font-size: 14px !important;\n    line-height: 20px !important;\n\n}\n\n.user__info__name {\n    border: none;\n    background: none;\n    outline: none;\n}\n\n.user__avatar {\n    object-fit: cover;\n}\n\n.qr__opacity {\n    opacity: 0 !important;\n}\n\n.uploda__user__image {\n    width: 18px;\n    height: 18px;\n    margin-right: 8px\n}\n\n.qr__logo__opacity {\n    opacity: 0 !important;\n    display: none !important;\n}\n\n.user__name {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 60px;\n    white-space: nowrap;\n}\n\n.forgot__password__content {\n    width: 285px;\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 10px;\n}\n\n.forgot__passwors_text {\n    cursor: pointer;\n    font-weight: 500;\n    line-height: 15px;\n    font-size: 15px;\n    color: #214175;\n}\n\n.clean__all {\n    cursor: pointer;\n    font-weight: 500;\n    line-height: 15px;\n    font-size: 15px;\n    color: #214175;\n    width: 200px;\n    padding: 10px;\n    margin-bottom: 21px;\n}\n\n\n.trash__delete__modal__content .card__product__stake__amount {\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n\n.approve_btn {\n    margin: auto;\n    justify-content: center !important;\n}\n\n.approves__modal {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: auto;\n    z-index: 9;\n    position: absolute;\n}\n\n.requests__message {\n    word-break: break-all;\n    width: 85%;\n    margin: 3px auto !important;\n}\n\n.login_requests__message {\n    word-break: break-all;\n    width: 65%;\n    margin: 3px auto !important;\n}\n\n.psw_requests__message {\n    word-break: break-all;\n    width: 60%;\n    margin: 3px auto !important;\n    display: flex;\n    justify-content: center;\n}\n\n.light__defi__zoom {\n    position: absolute !important;\n    left: 0 !important;\n    right: 24px !important;\n}\n\n.PhoneInputInput {\n    width: 100% !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    outline: none !important;\n    font-size: 18px !important;\n    line-height: 23px !important;\n    transition: all 0.4s !important;\n}\n\n.PhoneInput {\n    padding: 0 10px !important;\n}\n\n\n.settings_error_message {\n    text-align: center;\n    font-size: 13px;\n    line-height: 23px;\n    color: #be6161;\n    display: flex;\n    margin: 3px 0 5px 0;\n    justify-content: center;\n}\n\n\n.view__icon {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    right: 10px;\n    position: absolute;\n}\n\n.notificaten__password__content {\n    position: relative;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n\n}\n\n.notificaten__password__icon {\n    position: absolute;\n    right: 6px;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    display: flex;\n    margin: auto;\n    top: 15px;\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n}\n\n.email__title {\n    width: 380px;\n}\n\n.trash__error__modal,\n.unstake__error__modal {\n    width: 300px;\n    min-height: 200px;\n    height: fit-content;\n    position: fixed;\n    z-index: 99999999;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: #F0F0F3;\n    box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgb(174 174 192 / 40%);\n    border-radius: 24px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n\n}\n\n\n.unstake__error__modal {\n    width: 303px;\n    left: -19px;\n}\n\n.trash__error__modal__title,\n.unstake__error__modal__title {\n    font-size: 16px;\n    line-height: 21px;\n    width: 300px;\n    word-break: break-all;\n    padding: 0 10px;\n    color: #364048;\n    font-weight: 600;\n}\n\n.unstake__error__modal__title {\n    width: unset;\n}\n\n.alert__midal {\n    left: 0;\n}\n\n.trash__title__item {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 90px;\n    height: 1.2em;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    text-align: center;\n    margin: auto 0px;\n}\n\n\n\n.trash__zoom {\n    top: 70px !important;\n    right: 60px !important;\n    position: absolute !important;\n}\n\n.close__card__content {\n    position: absolute;\n    right: 15px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    height: 30px;\n    width: 30px;\n    z-index: 999;\n}\n\n.form__content__error {\n    margin-bottom: 0 !important;\n}\n\n\n.password__message {\n    width: 85%;\n}\n\n.accept_password__message {\n    width: 75%;\n    margin: 15px 0 !important;\n}\n\n.change_password__message {\n    width: 79%;\n}\n\n.version__title {\n    margin: 10px 20px;\n}\n\n.defi__card__unstake {\n    word-break: unset !important;\n}\n\n.active__page__main__container {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 10px;\n}\n\n.active__page__main {\n    background: #F0F0F3;\n    box-shadow: -10px -10px 30px #ffffff, 10px 10px 30px rgb(174 174 192 / 40%);\n    border-radius: 30px;\n    width: 60%;\n    padding: 20px 10px;\n    position: relative;\n}\n\n.active_loading__layer {\n    position: unset !important;\n    width: unset !important;\n    height: unset !important;\n}\n\n.alerts__input__wrapper div {\n    display: flex !important;\n    align-items: center !important;\n}\n\n.listing_error_message,\n.error_message {\n    color: rgb(190, 97, 97) !important;\n    align-items: center;\n    text-align: center;\n    display: flex;\n    font-size: 14px;\n    justify-content: center;\n    font-weight: 500;\n}\n\n.listing_error_message {\n    font-size: 18px;\n    margin-bottom: 10px;\n}\n\n.light_defi_row {\n    justify-content: center !important;\n    align-items: center !important;\n\n}\n\n\n.card__nft__wrapper_content {\n    justify-content: start !important;\n    width: 100%;\n    max-height: 200px;\n    overflow: auto;\n    min-height: auto\n}\n\n.light_ntf_item_content {\n    width: 100%;\n    padding: 10px;\n}\n\n.light_ntf_item {\n    padding: 5px;\n    cursor: pointer;\n    color: #717679;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 3px;\n}\n\n.light_ntf_item:hover {\n    color: #1762A2 !important;\n}\n\n.card__nft__wrapper_content::-webkit-scrollbar {\n    background-color: none !important;\n    width: 0 !important;\n}\n\n.light_ntf_item_img {\n    height: 20px;\n    width: 20px;\n    border-radius: 50px;\n}\n\n.light_ntf_item_span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 100px;\n    height: 1.2em;\n    white-space: nowrap;\n}\n\n.wallet__close__card {\n    z-index: 9 !important;\n    height: 15px;\n}\n\n.wallet__form__header {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    align-items: center;\n\n}\n\n.card__wallet__rates_input {\n    border: none;\n    background: none;\n    outline: none;\n    color: #889096;\n    line-height: 26px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n\n.trash__card__title {\n    margin: 0 !important;\n}\n\n.trash__card__row {\n    margin-bottom: 8px !important;\n}\n\n.card__product__stake__block__light_defi {\n    opacity: 0 !important;\n}\n\n.alert__input__modal {\n    width: 300px;\n    min-height: 200px;\n    height: fit-content;\n    position: absolute;\n    z-index: 99999999;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: #F0F0F3;\n    box-shadow: -8px -8px 24px #ffffff, 8px 8px 24px rgb(174 174 192 / 40%);\n    border-radius: 24px;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n\n    flex-direction: column;\n}\n\n.alert_btn_content {\n    display: flex;\n    width: 70%;\n    justify-content: space-between;\n    align-items: center;\n}\n\n\n.filter__icon {\n    margin-right: -8px;\n    cursor: pointer;\n}\n\n.chart__container {\n    position: fixed;\n    z-index: 999999;\n    width: fit-content;\n    height: fit-content;\n    display: flex;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: auto;\n}\n\n.wallet__add {\n    width: 32px !important;\n    height: 32px !important;\n    position: absolute !important;\n    top: 10px !important;\n    left: 10px !important;\n}\n\n.adderss_input {\n    width: 100% !important;\n    font-size: 17px !important;\n\n}\n\n.wallet__address__container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.address_input__wrapper {\n    width: 100% !important;\n    margin-bottom: 6px !important;\n    padding: 0 23px 0 50px;\n    font-size: 17px !important;\n\n}\n\n.wallet_address_content {\n    position: relative;\n    width: 96%;\n    margin-left: 60px;\n}\n\n.addresses_items {\n    display: flex;\n    flex-direction: column;\n    width: 100% !important;\n}\n\n.recucle__zoom_btn {\n    margin-right: -45px !important;\n}\n\n\n.empty__trash_container .main:after {\n    content: none !important;\n    height: none !important;\n}\n\n.empty__trash_container .main .content {\n    width: 100% !important;\n}\n\n.asset__list_filter {\n    font-weight: 700 !important;\n}\n\n.WhitelistForm__container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.alerts__input__wrapper__container {\n    align-items: center;\n    text-align: center;\n    width: 370px;\n    margin-bottom: 20px;\n}\n\n.light_ntf_item_information {\n    display: flex;\n    align-items: center;\n}\n\n.light_ntf_item_span {\n    margin-left: 10px;\n}\n\n.chart__card__title {\n    margin: 0 0 17px 0 !important;\n    font-size: 17px !important;\n}\n\n.trash .card__product__title {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 90px;\n    white-space: nowrap;\n}\n\n.ntf__filter__content {\n    width: 100%;\n    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);\n    border-radius: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 35px;\n    margin-bottom: 5px;\n}\n\n.ntf__filter__input {\n    border: none;\n    background: none;\n    outline: none;\n    font-size: 12px;\n    line-height: 23px;\n    font-weight: 500;\n    color: #889096 !important;\n    width: 100%;\n    padding: 0 5px;\n}\n\n.light_ntf_item_isExist {\n    background: #88909644 !important;\n    border-radius: 24px !important;\n}\n\n\n.contract__address_main_content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    text-align: center;\n}\n\n.contract__address_btn {\n    width: 100px !important;\n    font-size: 14px !important;\n    height: 35px !important;\n}\n\n.contract__address_content {\n    height: 35px;\n    width: 500px;\n}\n\n.chart__catent__value {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    margin: auto;\n}\n\n.all_conections_ntf {\n    width: 130px;\n}\n\n\n.page__loading__layer {\n    position: absolute !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    z-index: 999 !important;\n}\n\n\n.unstake__error_message {\n    color: rgb(190, 97, 97);\n    align-items: center;\n    text-align: center;\n    display: flex;\n    font-size: 13px;\n    justify-content: center;\n    font-weight: 600;\n    line-height: 15px;\n    padding: 0 1pc;\n}\n\n.email__input__add {\n    width: 280px !important;\n    margin: 0 auto;\n}\n\n.line__chart {\n    padding: 0 10px;\n}\n\n.limit__block__wrapper_container {\n    position: relative;\n}\n\n.walletShildAccept {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    padding: 16px;\n    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);\n    border-radius: 16px;\n    background-color: #f0f0f3;\n    width: 540px;\n    margin-top: 5px;\n}\n\n.wallet_accept__type__save {\n    width: 100%;\n    height: 32px;\n    border-radius: 67px;\n    box-shadow: -5px -5px 15px 0 #fff, 5px 5px 15px 0 rgb(174 174 192 / 40%);\n    background-color: #214175;\n    font-size: 15px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    cursor: pointer;\n    border: 0;\n}\n\n.wallet_input_form {\n    display: flex;\n    flex-direction: column;\n}\n\n.wallet_input_form_title {\n    text-decoration: none;\n    color: #9CA3A8;\n    font-weight: 600;\n    font-size: 14px;\n    border: none;\n    outline: none;\n    line-height: 23px;\n    margin-bottom: 5px;\n}\n\n.wallet_input_form_input {\n    border: none;\n    outline: none;\n    transition: all 0.4s;\n    height: 40px;\n    background: #F0F0F3;\n    border-radius: 67px;\n    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);\n    display: flex;\n    align-items: center;\n    width: 100px;\n    text-align: center;\n    color: #9CA3A8;\n    font-weight: 400;\n    font-size: 13px;\n}\n\n.wallet_input_form_container {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    width: 400px;\n    margin: 0 auto 15px;\n}\n\n.assets__wallet__type {\n    position: absolute !important;\n    z-index: 99;\n}\n\n.wallet__shild__card__header {\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n\n\n.rangeslider-vertical .rangeslider__handle {\n    outline: none !important;\n}\n\n.rangeslider-horizontal .rangeslider__handle {\n    outline: none !important;\n}\n\n.whitelist__close__card {\n    top: 0 !important;\n    right: 6px !important;\n}\n\n\n\n.open__trush {\n    left: 28px !important;\n    width: 210px !important;\n}\n\n.wallet__addresses__top__right {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.wallet__first__type {\n    top: 0;\n}\n\n.wallet__modal {\n    padding: 0 24px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.wallet__remove {\n    font-size: 47px;\n    display: flex;\n    margin-top: -12px;\n    color: #2167A4;\n}\n\n.partner_img_item {\n    object-fit: contain !important;\n}\n\n\n.partner__guard__title {\n    font-size: 13px;\n}\n\n\n.selected__item {\n    color: #214175 !important;\n    font-size: 19px !important;\n    font-weight: 700 !important;\n}\n\n.hours_title {\n    margin-left: 5px;\n}\n\n\n.risk__text {\n    color: #889096;\n    font-weight: 600;\n    font-size: 14px;\n    position: absolute;\n    margin: 7px 0;\n    line-height: 18px;\n    font-family: sans-serif;\n}\n\n.heder_title {\n    font-weight: bold;\n}\n\n.input-box {\n    display: flex;\n    overflow: hidden;\n    font-family: sans-serif;\n    width: 100%;\n    height: 100%;\n}\n\n.flex_input {\n    flex-grow: 1;\n    max-width: 60%;\n    outline: none;\n    border: none;\n    background: none;\n    color: #4DC7B5;\n    font-weight: 600;\n    font-size: 18px;\n}\n\n.prefix {\n    font-weight: 300;\n    color: #4DC7B5;\n    font-weight: 600;\n    font-size: 18px;\n    padding: 0 5px;\n    width: max-content;\n    height: fit-content;\n}\n\n.flex_input::placeholder {\n    font-size: 14px;\n    color: #4DC7B5;\n}\n\n.listening_main_wrapper {\n    height: calc(100vh - 56px);\n    padding-left: 72px;\n    margin-left: 24px;\n    margin-right: 24px;\n    margin-top: 40px;\n    background: #F0F0F3;\n    /* width: 100%; */\n    transition: padding-left 0.4s;\n}\n\n.listening_main_wrapper.open {\n    padding-left: 325px;\n}\n\n.listening_tabs_main_wrapper {\n    /* width: 960px; */\n    width: 100%;\n    height: 56px;\n    /* display: flex; */\n}\n\n.listening_tabs_wrapper {\n    display: flex\n}\n\n.listening_tab_wrapper {\n    width: 240px;\n    height: 56px;\n    border-radius: 24px 24px 0px 0px;\n    padding: 8px;\n    background-color: #E8E8E8;\n    margin-right: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n\n.listening_tab_wrapper:last-child {\n    margin-right: 0;\n}\n\n.listening_tab_wrapper:hover {\n    background-color: white;\n}\n\n.listening_tab_text {\n    font-family: Assistant;\n    font-size: 18px;\n    font-weight: 600;\n    text-align: center;\n    color: #364048\n}\n\n.active_tab>.listening_tab_text {\n    font-weight: bold;\n\n}\n\n.listening_search_wrapper {\n    display: flex;\n    box-shadow: inset 5px 5px 5px rgb(174 174 192 / 20%), inset -5px -5px 5px rgb(255 255 255 / 70%);\n    width: 226px;\n    height: 32px;\n    position: relative;\n    border-radius: 24px;\n}\n\n.assets_search_wrapper {\n    width: 315px;\n    margin-bottom: 8px;\n}\n\n.listening_search_icon_wrapper {\n    box-shadow: inset -5px -5px 5px 0px #FFFFFFBF, inset 5px 5px 5px 0px #AEAEC033;\n    border-radius: 50%;\n    height: 32px;\n    width: 32px;\n    display: flex;\n    background-image: url(Assets/img/icons/loop.png);\n    background-repeat: no-repeat;\n    background-position: center center;\n    position: absolute;\n    outline: none;\n}\n\n.listening_search_field {\n    background: transparent;\n    border: none;\n    width: 100%;\n    padding-left: 40px;\n}\n\n.listening_search_field:focus {\n    outline: none;\n}\n\n.listing_search_row {\n    /* width: 1768px; */\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    padding: 0 40px;\n    margin-bottom: 24px;\n}\n\n.listing_export_customize_columns_wrapper {\n    display: flex;\n    /* margin-right: 16px; */\n    gap: 20px;\n}\n\n.listing_export {\n    cursor: pointer;\n    width: 123px;\n    height: 32px;\n    padding: 4px 24px 4px 16px;\n    gap: 8px;\n    border-radius: 24px;\n    border: 1px 0px 0px 0px;\n    opacity: 0px;\n    border: 1px solid #214175;\n    font-family: Assistant;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 23.54px;\n    color: #214175;\n}\n\n.listing_export_icon {\n    margin-right: 16px;\n}\n\n.listing_customize_icon {\n    margin-right: 11px;\n}\n\n/* .listing_customize {\n    cursor: pointer;\n\n    padding-left: 16px;\n    padding-right: 24px;\n    height: 32px;\n    width: 48px;\n    gap: 8px;\n    border-radius: 24px;\n    opacity: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #214175;\n    color: white;\n    font-family: Assistant;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 23.54px;\n    text-align: left;\n    margin-left: 16px;\n    border: none\n} */\n.listing_customize {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    overflow: hidden;\n    width: 60px;\n    /* small initial width for icon */\n    height: 32px;\n    padding: 0 20px;\n    background: transparent;\n    color: #214175;\n    border: 1px solid #214175;\n    border-radius: 24px;\n    cursor: pointer;\n    transition: width 0.4s ease, background-color 0.3s ease, color 0.3s ease;\n    gap: 12px;\n}\n\n/* Special styling for the first button */\n.listing_customize:last-child {\n    background-color: #214175;\n    /* border: 1px solid #214175; */\n    color: #ffffff;\n}\n\n.listing_customize:last-child:hover {\n    background-color: #2267a4;\n}\n\n/* Hover for all buttons */\n.listing_customize:hover {\n    width: 110px;\n    padding-right: 10px;\n    border-color: #2267a4;\n}\n\n/* Hover for the first button only */\n.listing_customize:first-child:hover {\n    background-color: #ffffff;\n    color: #2267a4;\n    border-color: #2267a4;\n}\n\n/* Icon */\n.listing_customize i {\n    font-size: 18px;\n    flex-shrink: 0;\n    transition: transform 0.3s ease;\n}\n\n/* Text hidden by default */\n.listing_customize span {\n    opacity: 0;\n    white-space: nowrap;\n    transform: translateX(-20px);\n    transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n/* Reveal text on hover */\n.listing_customize:hover span {\n    opacity: 1;\n    transform: translateX(0);\n    position: relative;\n    right: 5px;\n}\n\n.listing_customize:hover .icon-export:before {\n    content: \"\\e900\";\n    color: #2267a4;\n}\n\n.listing_customize:hover .icon-customize:before {\n    content: \"\\e900\";\n    color: #2267a4;\n}\n\n.listing_customize:hover span {\n    color: #2267a4;\n}\n\n.listing_customize:last-child:hover span {\n    color: #fff;\n}\n\n\n.listing_customize_icon {\n    content: \"\\e900\";\n    color: #2267a4 !important;\n}\n\n/*Dropdown style*/\n/* ---------------------------\n   Dropdown button (no expand)\n   --------------------------- */\n\n/* Make dropdown button size based on content (no small-icon compact state) */\n.listing_score_algorithm {\n    width: auto !important;\n    /* let content determine width */\n    min-width: 120px;\n    /* optional: ensure a reasonable minimum */\n    padding: 0 14px;\n    /* visible spacing */\n    transition: none !important;\n    /* disable width/color transitions */\n    background: #214175;\n    /* keep the same base BG as other buttons */\n    color: #fff;\n    border: none;\n    /* switch to border if you prefer outline */\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n}\n\n/* Ensure the span text is always visible (no hidden text) */\n.listing_score_algorithm span {\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n}\n\n/* Prevent hover from changing width or hiding text */\n.listing_score_algorithm:hover {\n    width: auto !important;\n    background-color: #2267A4;\n    /* optional hover color */\n}\n\n/* If you used :first-child or other generic selectors earlier,\n   make sure dropdown's visibility doesn't get overridden */\n.listing_score_algorithm:first-child,\n.listing_score_algorithm:focus,\n.listing_score_algorithm.ant-dropdown-open {\n    width: auto !important;\n    min-width: 120px;\n}\n\n/* Optional: icon sizing and spacing */\n.listing_score_algorithm i {\n    font-size: 16px;\n    flex-shrink: 0;\n}\n\n\n.listing_saveUs {\n    border: 1px solid #214175;\n    color: #214175;\n    background-color: transparent;\n    text-decoration: none;\n}\n\n.listing_score_algorithm {\n    width: 200px;\n    height: 32px;\n    opacity: 1;\n    border-radius: 24px;\n    background: #F0F0F3;\n    box-shadow: -8px -8px 24px 0px #FFFFFF;\n    box-shadow: 4px 4px 8px 0px #AEAEC066;\n    display: flex;\n    justify-content: flex-start;\n}\n\n.listing_score_algorithm>span {\n    font-family: Assistant;\n    font-weight: 600;\n    font-size: 16px;\n    color: #364048;\n    position: relative;\n    z-index: 11;\n}\n\n/* Dropdown container */\n.algorithm-dropdown-overlay {\n    padding: 0 !important;\n    border-radius: 0 0 8px 8px !important;\n    overflow: hidden;\n    background: #F0F0F3;\n    box-shadow: 0px 12px 12px rgba(0, 0, 0, 0.15);\n    will-change: transform, opacity;\n    /* animation: dropdown-slide 0.25s ease forwards; */\n    /* inset: 204px auto auto 1372px !important; */\n    inset: 204px auto auto 1462px !important;\n    width: 154px;\n    z-index: 10;\n}\n\n.custom-tooltip-position {\n    inset: 218px 366px auto auto !important;\n}\n\n/* Accordion-like slide down */\n@keyframes dropdown-slide {\n    from {\n        opacity: 0;\n        transform: translateY(-6px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Menu items container */\n.algorithm-dropdown-menu {\n    display: flex;\n    flex-direction: column;\n    min-width: 200px;\n    margin-top: 20px;\n}\n\n/* Each item */\n.algorithm-dropdown-item {\n    padding: 8px 14px;\n    cursor: pointer;\n    font-size: 16px;\n    font-family: Assistant;\n    font-weight: 600;\n    color: #364048;\n    border-top: 1px solid #e5e5e5;\n    transition: background 0.2s ease;\n}\n\n/* Remove bottom border on last item */\n.algorithm-dropdown-item:last-child {\n    border-bottom: none;\n}\n\n/* Hover + active styles */\n.algorithm-dropdown-item:hover {\n    background: #f5f7fa;\n}\n\n.algorithm-dropdown-item.active {\n    background: #e4e6e9;\n    font-weight: 600;\n    /* color: #1677ff; */\n}\n\n.listing_modal_head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 27px;\n}\n\n.listing_modal_title {\n    font-family: Assistant;\n    font-size: 22px;\n    font-weight: 700;\n    color: #364048;\n}\n\n.listing_modal_close_icon {\n    height: 14px;\n    width: 14px;\n    margin-right: 32px;\n    cursor: pointer\n}\n\n.listing_volumes_wrapper {\n    width: 90%;\n    height: 496px;\n    overflow: auto;\n}\n\n.listing_single_volume_wrapper {\n    display: flex;\n    align-items: center;\n    height: 48px;\n    gap: 8px;\n    cursor: pointer;\n}\n\n.listing_single_volume_checkbox {\n    width: 18.67px;\n    height: 18.67px;\n    top: 6.67px;\n    left: 6.67px;\n    gap: 0px;\n    border-radius: 1.33px 0px 0px 0px;\n    border: 9.33px 0px 0px 0px;\n    opacity: 0px;\n    border: 9.33px solid #2267A4;\n    margin-right: 14.67px;\n    cursor: pointer;\n}\n\n.listing_volumes_divider {\n    margin: 8px 0;\n    border: 1px solid #D8D8E0\n}\n\n.listing_modal_submit {\n    width: 138px;\n    height: 32px;\n    gap: 8px;\n    border-radius: 24px;\n    opacity: 0px;\n    background: #214175;\n    font-family: Assistant;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 23.54px;\n    text-align: left;\n    border: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    cursor: pointer;\n}\n\n.listing_modal_submit_wrapper {\n    display: flex;\n    justify-content: flex-end;\n    margin: 27px 40px 0 0;\n}\n\n.active_tab {\n    box-shadow: -3px -3px 6px 0px rgba(255, 255, 255, 1), 3px -6px 6px 0px rgba(174, 174, 192, 0.4);\n    background-color: #F0F0F3;\n}\n\n.listing_content_wrapper {\n    /* width: 1768px; */\n    width: 100%;\n    background-color: #F0F0F3;\n    box-shadow: -8px -8px 24px 0px #FFFFFF, 8px 8px 24px 0px #AEAEC066;\n    padding-top: 32px;\n    border-radius: 0 24px 24px 24px;\n    background-color: #F0F0F3;\n}\n\n.listing_asset_modal_head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 37px;\n}\n\n.listing_asset_modal_title {\n    font-family: Assistant;\n    font-size: 22px;\n    font-weight: 700;\n    text-align: left;\n}\n\n.listing_asset_modal_money_field {\n    width: 475px;\n    height: 32px;\n    border-radius: 24px;\n    background-color: #F0F0F3;\n    box-shadow: inset -5px -5px 5px 0px rgba(255, 255, 255, 0.75), inset 5px 5px 5px 0px rgba(174, 174, 192, 0.2);\n    border: none;\n    padding-left: 16px;\n    font-size: 18px;\n}\n\n.listing_asset_modal_money_field_wrapper {\n    margin-bottom: 30px;\n}\n\n.listing_change_alert_wrapper {\n    display: flex;\n    align-items: center;\n}\n\n.listing_change_alert_checkbox {\n    width: 18.67px;\n    height: 18.67px;\n    border-radius: 1.33px;\n    border: 9.33px;\n    margin-right: 15px;\n}\n\n.listing_change_alert_text {\n    font-family: Assistant;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 23.54px;\n}\n\n.listing_change_enter_your_details {\n    font-family: Assistant;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 23.54px;\n}\n\n\n.listing_table_wrapper {\n    height: 70vh;\n    /* height: 580px; */\n    /* width: 1768px; */\n    margin-bottom: 50px;\n    width: 100%;\n    overflow: auto;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.listing_table {\n    border-radius: 24px;\n    min-width: max-content;\n    /* margin-top: 61px; */\n}\n\n.listing_table_row_wrapper {\n    display: block;\n    padding: 18px 0px;\n    border-top: 1px solid #D8D8E0;\n    border-bottom: 1px solid #D8D8E0;\n    min-width: 1768px;\n}\n\n.hover:hover {\n    background-color: #D8D8E0;\n}\n\n.hover:hover .headcol {\n    background-color: #D8D8E0;\n}\n\n.highlighted_row {\n    background-color: #E9E9EC;\n}\n\n.highlighted_row td {\n    font-family: Assistant;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 23.54px;\n    color: #364048;\n}\n\n.highlighted_row td span {\n    padding-left: 55px;\n}\n\n.listing_table_first_column,\n.listing_table_titles,\n.listing_table_datas {\n    width: 202px;\n    font-family: Assistant;\n    font-size: 18px;\n    line-height: 23.54px;\n    text-align: left;\n    color: rgba(54, 64, 72, 1);\n    position: relative;\n    /* z-index: 1; */\n    padding-left: 20px;\n}\n\n.listing_table_titles {\n    font-weight: 700;\n    /* color: rgba(136, 144, 150, 1); */\n    color: #364048;\n}\n\n.listing_table_yes,\n.listing_table_no {\n    font-family: Assistant;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 23.54px;\n}\n\n.listing_table_yes {\n    color: rgba(77, 199, 181, 1);\n}\n\n.listing_bolded_row {\n    font-weight: bold;\n    text-transform: capitalize;\n}\n\n.listing_table_no {\n    color: rgba(245, 180, 82, 1);\n}\n\n.listing_asset_edit_value {\n    font-size: 16px;\n    font-weight: bold;\n    padding-left: 8px !important;\n    color: #364048;\n\n}\n\n.listing_asset_edit_icon {\n    height: 12px;\n    width: 12px;\n\n    cursor: pointer;\n    margin-left: 7px;\n}\n\n.listing_asset_edit {\n    display: inline-block;\n    margin-left: 5px;\n    box-sizing: border-box;\n    cursor: pointer;\n    position: absolute;\n    /* right: 35px; */\n}\n\n.listing_asset_edit:hover {\n    background-color: rgba(34, 103, 164, 0.2);\n    border-radius: 4px;\n    width: 24px;\n    /* padding: 3px 0; */\n    box-sizing: border-box;\n}\n\n.listing_asset_edit_icon:hover>path {\n    fill: #2267A4;\n\n}\n\n.listing_asset_modal_money_field::-webkit-outer-spin-button,\n.listing_asset_modal_money_field::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.listing_filter_volums_wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 24px;\n    width: 24px;\n    margin-left: 8px;\n    cursor: pointer\n}\n\n.listing_filter_volums_wrapper:hover {\n    border-radius: 5px;\n    background-color: #C7D5E3\n}\n\n.listing_filter_volums {\n    height: 12px;\n    width: 12px;\n}\n\n.assetRowWrapper {\n    display: flex;\n    align-items: center;\n}\n\n\ntable {\n    border-collapse: separate;\n    border-spacing: 0;\n    /* border-top: 1px solid grey; */\n}\n\n\n.headcol {\n    position: sticky !important;\n    z-index: 2;\n    left: 0;\n    top: auto;\n    background-color: #f0f0f3;\n\n    /*border-top-width: 1px;    \n     \n    margin-top: -1px;\n    padding: 18px 40px; */\n    /*compensate for top border*/\n}\n\n/* .headcol>span{\n    position:fixed;\n  } */\n.headcol::after {\n    position: absolute;\n    top: -18px;\n    right: 0;\n    bottom: -30px;\n    width: 23px;\n    /* transform: translateX(100%); */\n    box-shadow: 8px 0 16px -7px rgba(174, 174, 192, 0.4);\n    content: \"\";\n    pointer-events: none;\n}\n\n.headrow {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background-color: #f0f0f3;\n    width: 93%;\n    margin-top: -1px\n}\n\n.headcol span {\n    padding-left: 40px;\n    max-width: 100%;\n    display: inline-block;\n    white-space: nowrap;\n}\n\n.PhoneInputInput {\n    text-align: center;\n    margin-right: 35px;\n}\n\n.error__message {\n    white-space: nowrap;\n}\n\n.password__message {\n    white-space: break-spaces;\n}\n\n.ant-tooltip .ant-tooltip-content {\n    width: 429px;\n}\n\n.security-tooltip .ant-tooltip-content {\n    width: 720px;\n}\n\n.custom-toolTip p,\n.custom-toolTip h2 {\n    padding-bottom: 12px;\n}\n\n.security-tooltip p,\n.security-tooltip h2 {\n    padding-bottom: 10px;\n}\n\n.custom-toolTip {\n    padding: 15px;\n    overflow: auto;\n}\n\n::placeholder {\n    color: #949ba0;\n}\n\n.generalText {\n    width: 200px;\n    /* word-break: break-all; */\n    white-space: normal;\n    overflow-wrap: break-word;\n    /* hyphens: auto; */\n    font-family: Assistant;\n    font-size: 18px;\n    line-height: 23.54px;\n    text-align: left;\n    color: rgba(54, 64, 72, 1);\n}\n\n.deleteImage {\n    position: absolute;\n    top: 25px;\n    z-index: 10;\n    right: 40px;\n}\n\n.accordionArrow {\n    width: 8px;\n    position: relative;\n    left: 40px;\n    vertical-align: inherit;\n    transition: transform 0.3s ease;\n}\n\n.accordionArrowRotate {\n    transform: rotate(90deg);\n    width: 8px;\n    position: relative;\n    left: 40px;\n    vertical-align: inherit;\n    transition: transform 0.3s ease;\n}\n\n.alertIconClicked.icon-alert:before {\n    background: #2267A4;\n    vertical-align: text-top;\n    box-sizing: border-box;\n    border-radius: 5px;\n    display: flex;\n    color: #C7D5E3 !important;\n    justify-content: center;\n    align-items: center;\n}\n\n.ant-notification-notice-wrapper {\n    border-left: 5px solid #2267A4;\n    height: 65px;\n    border-radius: 5px;\n}\n\n\n\n.zoom__page .add_staking {\n    top: 48% !important;\n}\n\n\n.tooltip .rangeslider__handle-tooltip {\n    left: 100%;\n    /* push to right of the slider */\n    margin-left: 15px;\n    /* add some spacing */\n    top: 50%;\n    transform: translateY(-50%);\n\n}\n\n@media (max-width: 1920px) {\n    .add_staking {\n        top: 43% !important;\n    }\n}\n\n@media (max-width: 1320px) {\n\n    .listing_table_wrapper {\n        height: 68vh;\n    }\n}\n\n.zoom__page .sr-right-header {\n    width: 58% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
